const INPUT_ERROR_CLASS = 'input--error';
const INPUT_VISITED_CLASS = 'input--visited';

export default class Input {
  handleFocus = ({ target }) => {
    target.parentNode.classList.add(INPUT_VISITED_CLASS);
  };

  handleBlur = ({ target }) => {
    if (!target.value) {
      target.parentNode.classList.remove(INPUT_VISITED_CLASS);
    }
  };

  handleInput = ({ target }) => {
    const { parentNode } = target;

    if (parentNode.classList.contains(INPUT_ERROR_CLASS)) {
      target.parentNode.classList.remove(INPUT_ERROR_CLASS);
      const errorMessage = document.querySelector(`.input__error-message[data-target="${target.id}"]`);
      errorMessage.remove();
    }
  };

  initializeEventListeners = (container = document) => {
    const inputs = container.querySelectorAll('.js-text-input .input__field');

    [...inputs].forEach((element) => {
      if (element.value.trim()) {
        element.parentNode.classList.add(INPUT_VISITED_CLASS);
      }
      element.addEventListener('focus', this.handleFocus);
      element.addEventListener('blur', this.handleBlur);
      element.addEventListener('input', this.handleInput);
    });
  };
}
